import { Props } from "..";

type StatusPhasesProps = {
  cause: string | null | undefined;
} & Pick<
  Props,
  | 'maintenancePhaseOneLabel'
  | 'maintenancePhaseTwoLabel'
  | 'maintenancePhaseThreeLabel'
  | 'outagePhaseOneLabel'
  | 'outagePhaseTwoLabel'
  | 'outagePhaseThreeLabel'
>;

export const setStatusVariants = ({ cause, ...rest }: StatusPhasesProps) => {
  const maintenancePhases = [
    rest.maintenancePhaseOneLabel,
    rest.maintenancePhaseTwoLabel,
    rest.maintenancePhaseThreeLabel,
  ].filter((val): val is string => val !== undefined);

  const outagePhases = [
    rest.outagePhaseOneLabel,
    rest.outagePhaseTwoLabel,
    rest.outagePhaseThreeLabel,
  ].filter((val): val is string => val !== undefined);

  return cause === 'Onderhoud' ? maintenancePhases : outagePhases;
};
